export function marketError(error: unknown, local: boolean) {
  if (error instanceof Error && (error.name === 'AbortError' || /timed out|timeout/i.test(error.message))) return {
    title: 'Sambungan harga mengambil masa',
    message: 'Sumber harga lambat menjawab. Mencuba semula secara automatik.',
  };
  if (error instanceof TypeError) return {
    title: local ? 'Sambungan localhost terputus' : 'Sambungan terputus',
    message: local
      ? 'Pelayan localhost tidak dapat dicapai. Hidupkan semula ZonePips; chart akan menyambung semula secara automatik.'
      : 'Sambungan ke pelayan harga gagal. Semak internet; chart akan mencuba semula.',
  };
  return { title: 'Data pair belum tersedia', message: error instanceof Error ? error.message : 'Sumber harga belum tersedia. Mencuba semula.' };
}
